import React from "react";
import {useDispatch} from "react-redux";
import {setCloseInitiated} from "../../store/verification.slice";
import {Button} from "@nextui-org/react";
import {BackIcon} from "../icons/BackIcon";
import {CloseIcon} from "../icons/CloseIcon";
import {Logo} from "../icons/Logo";
import {useTheme} from "../../theme/ThemeProvider";


function Header({goBack, closeEnabled = true, color = "var(--urtentic-sdk-primary, #000000)"}) {
    const dispatch = useDispatch();
    const {logoUrl} = useTheme();

    const close = () =>{
        dispatch(setCloseInitiated(true))
    }

    return (
        <div className="flex p-2 flex-row justify-between w-full">
            {/* Back Button */}
            <div>
            {goBack && <Button onClick={() => goBack()} isIconOnly variant="ghost">
                <BackIcon height={24} width={24} fill={color}/>
            </Button>}
            </div>

            {/* Logo and Text Centered — a custom logoUrl replaces the whole
                icon+wordmark unit (it's the customer's own brand mark), not
                just the icon beside "URTENTIC" */}
            <div className="flex flex-row justify-center items-center">
                <Logo logoUrl={logoUrl}/>
                {!logoUrl && (
                    <div style={{color: color}} className="font-bold text-xl ml-2">URTENTIC</div>
                )}
            </div>

            {/* Placeholder for symmetry or additional control */}
            <div className="p4 w-10">
                {/* Invisible placeholder to balance the layout */}
                {
                    window !== window.top && closeEnabled && <Button onClick={() => close()} isIconOnly variant="ghost">
                        <CloseIcon height={24} width={24} fill={color} />
                    </Button>
                }
            </div>
        </div>
    );
}

export default Header;
